module.exports = __webpack_public_path__ + "img/15.a9ba123f.jpg";